import { getAge } from '@lib/getAge'

type preFilterProps = {
  dobYear: string
  dobMonth: string
  dobDay: string
  useDefaultFilter: boolean
  currentPlans: PlanName[]
  plans: Record<PlanName, Quote[]> | {}
}

export const preFilterPlans = ({
  currentPlans = [],
  dobYear,
  dobMonth,
  dobDay,
  useDefaultFilter,
  plans,
}: preFilterProps): PlanName[] => {
  const dob = new Date(+dobYear, +dobMonth, +dobDay)
  if (!useDefaultFilter || dob.getDate() === NaN) {
    return currentPlans
  }
  const planName: PlanName = getPlanByAge({ dobYear, dobMonth, dobDay }) || 'F'

  const hasQuotes = Object.keys(plans).filter(key => plans[key].length).length > 0
  const planCount = plans[planName] ? plans[planName].length : 0
  const planList = Object.keys(plans).filter(key => key !== planName) as PlanName[]

  return !hasQuotes || planCount > 0 ? planList : []
}


type PlanByAgeProps = {
  dobYear: string
  dobMonth: string
  dobDay: string
}

export const getPlanByAge = ({
  dobYear,
  dobMonth,
  dobDay,
}: PlanByAgeProps): PlanName | null => {
  const dob = new Date(+dobYear, +dobMonth - 1, +dobDay)

  const hasDob = dobYear && dobMonth && dobDay
  if (!hasDob || dob.getDate() === NaN) {
    return null
  }
  const age = getAge(dob)

  let planName: PlanName = 'G'

  if (age > 65) {
    planName = 'F'
  }

  return planName
}
